import * as React from 'react';
import { SVGProps } from 'react';

const AICommentIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="197"
    height="154"
    fill="none"
    viewBox="0 0 197 154"
    {...props}
  >
    <g opacity="0.8">
      <path
        fill="url(#paint0_radial_1152_62364)"
        d="M158.86 70.48c-2.05 12.34-15.86 20.67-30.85 18.61-14.98-2.06-25.46-13.73-23.41-26.07s15.86-20.67 30.85-18.61c14.98 2.06 25.46 13.73 23.41 26.07"
      ></path>
      <path
        fill="url(#paint1_linear_1152_62364)"
        d="M122.7 6.99 87.89 1.75l40.95 64.44h4.83z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint2_linear_1152_62364)"
        d="m163.92 9.46 32.79 12.8-61.56 43.46-4.18-2.4z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint3_linear_1152_62364)"
        d="m79.19 119.03 31.96 4.09 21.87-55.61-7.43-.71z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint4_linear_1152_62364)"
        d="m175.1 117.29-25.12 1.28-16.88-50.02 4.54-.23z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint5_linear_1152_62364)"
        d="m192.06 68.32 2.51-22.77-61.47 19v6.16z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint6_linear_1152_62364)"
        d="m193.27 88.17 3.44-30.4-63.04 8.42-.57 2.36z"
        opacity="0.6"
      ></path>
      <path
        fill="url(#paint7_linear_1152_62364)"
        d="M83.88 44.36 80.1 67.89l53.55.96 1.15-4z"
      ></path>
      <path
        fill="url(#paint8_linear_1152_62364)"
        d="M74.87 50.5v24.22l59.93-4.01-.37-4.53z"
        opacity="0.6"
      ></path>
    </g>
    <path
      fill="#1F93CB"
      d="M93.15 45.62 90.4 31.96c-.4-1.97.88-3.89 2.85-4.29s3.64.95 4.29 2.85c1.53 4.5 2.43 8.98 2.75 13.66.14 2-.88 3.89-2.85 4.29s-3.89-.88-4.29-2.85"
    ></path>
    <path
      fill="#FFF46C"
      d="M100.28 44.19c.13 2.01-.88 3.9-2.85 4.29-.17.03-.32.05-.49.06 1.94-.41 2.49-2.23 2.36-4.22-.32-4.67-1.22-9.16-2.75-13.66-.58-1.68-1.5-2.98-3.17-2.98-.06 0-.12 0-.19.01.01 0 .03-.01.04-.01.24-.05.47-.07.68-.07 1.67 0 3.03 1.24 3.61 2.92 1.52 4.5 2.42 8.98 2.75 13.66z"
      opacity="0.23"
    ></path>
    <path
      fill="#42A9DB"
      d="M50.84 92.72c25.427 0 46.04-20.613 46.04-46.04S76.268.64 50.84.64C25.413.64 4.8 21.253 4.8 46.68s20.613 46.04 46.04 46.04"
    ></path>
    <path
      fill="#FFF46C"
      d="M58.62 92.06c-2.83.49-5.64.7-8.41.66 2.27-.05 4.57-.27 6.87-.66 25.05-4.29 42.03-27.69 37.54-52.72C90.44 16.06 71.97 1.13 50.39.64 72.62.38 92.36 16.3 96.23 38.9c4.3 25.06-12.54 48.86-37.6 53.15z"
      opacity="0.23"
    ></path>
    <path
      fill="#EFAA83"
      d="M85.25 57.74c.79 4.88-2.53 9.48-7.41 10.27s-9.48-2.53-10.27-7.41 2.53-9.48 7.41-10.27 9.48 2.53 10.27 7.41"
    ></path>
    <path
      fill="#FFF46C"
      d="M77.84 68.02c-.61.1-1.22.13-1.81.1.36-.01.74-.04 1.11-.1 4.88-.8 8.2-5.4 7.41-10.28-.68-4.28-4.32-7.37-8.51-7.51 4.48-.21 8.48 2.98 9.21 7.51.8 4.88-2.53 9.48-7.41 10.28"
      opacity="0.23"
    ></path>
    <path
      fill="#AC5E27"
      d="m47.81 18.3-3.37.58c-14.76 2.53-25.1 14.73-22.57 29.49l2.29 13.36a4.383 4.383 0 0 0 5.06 3.58l48.4-8.29a4.383 4.383 0 0 0 3.58-5.06l-1.96-11.41C76.71 25.79 62.56 15.78 47.8 18.31z"
    ></path>
    <path
      fill="#9E501B"
      d="m31.38 64.94-2.16.37a4.377 4.377 0 0 1-5.06-3.58l-2.29-13.36c-2.53-14.76 7.81-26.96 22.57-29.49l3.37-.58z"
    ></path>
    <path
      fill="#E19B7C"
      d="m64.17 78.75-14.64 1.5 1.27 12.38c.35 3.41 3.55 5.87 7.16 5.5l1.59-.16c3.6-.37 6.24-3.43 5.89-6.84z"
    ></path>
    <path
      fill="#EFAA83"
      d="m76.59 41.36 2.89 16.88c.23 1.32.34 2.63.36 3.93.02 1.06-.04 2.11-.15 3.15-1.23 10.79-9.43 19.93-20.67 21.86l-2.19.37c-13.64 2.34-26.6-6.83-28.93-20.47L25.01 50.2c-2.34-13.64 6.83-26.6 20.47-28.93l2.19-.37c13.64-2.34 26.6 6.83 28.93 20.47z"
    ></path>
    <path
      fill="#FFF46C"
      d="M79.84 62.33c.01 1.06-.04 2.11-.16 3.14-1.23 10.8-9.43 19.94-20.67 21.86l-2.19.38c-1.63.28-3.24.39-4.84.35 1.23-.02 2.47-.13 3.71-.35l2.19-.38c11.24-1.93 19.45-11.07 20.67-21.86.11-1.03.17-2.08.16-3.14-.02-1.3-.13-2.61-.36-3.93l-2.89-16.89C73.4 29.5 63.11 20.96 51.37 20.69c12.21-.28 23.1 8.42 25.22 20.82l2.89 16.89c.23 1.32.34 2.63.36 3.93"
      opacity="0.23"
    ></path>
    <path
      fill="#231F20"
      d="m67.118 52.129-.01.002a3.03 3.03 0 0 0-2.475 3.498l.294 1.715a3.03 3.03 0 0 0 3.498 2.475l.01-.002a3.03 3.03 0 0 0 2.475-3.498l-.294-1.715a3.03 3.03 0 0 0-3.498-2.475"
    ></path>
    <path
      fill="#C8886D"
      d="m58.503 60.489-3.597.616a1.42 1.42 0 0 0-1.16 1.64l.199 1.162a1.42 1.42 0 0 0 1.64 1.16l3.597-.616a1.42 1.42 0 0 0 1.16-1.64l-.2-1.163a1.42 1.42 0 0 0-1.639-1.16"
    ></path>
    <path
      fill="#C98A6D"
      d="M79.84 62.17c.02 1.06-.04 2.11-.15 3.15-.49.47-1.17.82-1.96.95-1.74.3-3.34-.55-3.57-1.89s.99-2.67 2.74-2.97c1.17-.2 2.28.11 2.95.76z"
      opacity="0.4"
    ></path>
    <path
      fill="#EFAA83"
      d="M36.98 66.02c.79 4.88-2.53 9.48-7.41 10.27s-9.48-2.53-10.27-7.41 2.53-9.48 7.41-10.27 9.48 2.53 10.27 7.41"
    ></path>
    <path
      fill="#E09975"
      d="M48.71 87.61a25.06 25.06 0 0 1-17.54-11.74c-.51.19-1.05.32-1.6.41a8.95 8.95 0 0 1-10.27-7.41 8.94 8.94 0 0 1 4.5-9.26 8.7 8.7 0 0 1 2.2-.86l3.36-7.91L65.98 33.9s2.66 11.59-8.94 14c-4.83 1-17.56 3.36-24.05 4.61-.9.17-1.38 1.03-1.33 1.94.29 4.73-.1 11.75 3.36 19.63 1.88 4.28 4.06 7.03 9.2 10.14 1.07.65 4.38 1.61 4.48 3.39z"
    ></path>
    <path
      fill="#C98A6D"
      d="M38.761 72.948c1.742-.299 2.968-1.626 2.739-2.965-.23-1.34-1.828-2.183-3.57-1.885-1.742.299-2.968 1.626-2.738 2.965.23 1.34 1.827 2.183 3.57 1.885"
      opacity="0.4"
    ></path>
    <path
      fill="#AC5E27"
      d="m24.74 51.34 2.29 13.36c.06.36.4.6.76.54l1.79-.31c1.18-.2 1.97-1.32 1.77-2.5l-2.02-11.88-4.6.79z"
    ></path>
    <path
      fill="#9E501B"
      d="m24.74 51.34 2.29 13.36c.06.36.4.6.76.54 1.18-.2 1.08-.8.88-1.98l-2.02-11.88-1.91-.05z"
    ></path>
    <path
      fill="#fff"
      d="M69.388 54.44a.87.87 0 0 0-1.715.295l.082.483a.87.87 0 1 0 1.716-.294z"
    ></path>
    <path
      fill="#E4E4E4"
      d="M73.39 108.24a9.28 9.28 0 1 0 0-18.56 9.28 9.28 0 0 0 0 18.56M42.6 111.4a9.28 9.28 0 1 0 0-18.56 9.28 9.28 0 0 0 0 18.56"
    ></path>
    <path
      fill="#EFEFEF"
      d="M33.3 103.3c1.22 16.59 2.59 40.54 2.59 40.54 1.63 15.84 54.18 10.45 52.55-5.4 0 0-3.89-24.97-5.72-40.23-.63-5.28-5.27-9.13-10.56-8.59-8.79.91-21.52 2.22-30.28 3.12-5.29.54-8.98 5.26-8.59 10.56z"
    ></path>
    <path
      fill="#fff"
      d="M85.19 145.46c2.66-2.71 2.07-8.77-.57-25.26-1.94-12.08-1.79-24.08-7.45-29.76 2.95 1.38 5.13 4.25 5.55 7.75 1.82 15.26 5.72 40.23 5.72 40.23.27 2.65-.97 5.03-3.25 7.04"
      opacity="0.52"
    ></path>
    <path
      stroke="#EFEFEF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="18.45"
      d="M73.39 98.96c17.53.32 29.55-3.11 37.12-15.29"
    ></path>
    <path
      fill="#26A4DC"
      d="m116.529 66.603-6.059 3.722a7.83 7.83 0 1 0 8.197 13.343l6.058-3.721a7.83 7.83 0 0 0-8.196-13.344"
    ></path>
    <path
      fill="#000"
      d="m114.12 79.26.34.56c.46.77 1.27 1.26 2.17 1.33l5.46.4 2.19-1.35z"
      opacity="0.11"
    ></path>
    <path
      fill="#870E7F"
      fillRule="evenodd"
      d="m146.92 80.7-29.97-.24a4.025 4.025 0 0 1-3.99-4.07l.23-17.9a4.023 4.023 0 0 1 4.05-3.97l29.97.24c2.23.02 4.02 1.85 3.99 4.07l-.23 17.9a4.023 4.023 0 0 1-4.05 3.97"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint9_linear_1152_62364)"
      fillRule="evenodd"
      d="m146.49 79.96-29.87-.24a3.685 3.685 0 0 1-3.65-3.72l.24-18.59a3.686 3.686 0 0 1 3.71-3.63l29.87.24c2.04.02 3.67 1.69 3.65 3.72l-.24 18.59a3.686 3.686 0 0 1-3.71 3.63"
      clipRule="evenodd"
    ></path>
    <path
      fill="#43D7EF"
      fillRule="evenodd"
      d="m146.49 79.96-29.87-.24a3.685 3.685 0 0 1-3.65-3.72l.24-18.59a3.686 3.686 0 0 1 3.71-3.63l29.87.24c2.04.02 3.67 1.69 3.65 3.72l-.24 18.59a3.686 3.686 0 0 1-3.71 3.63"
      clipRule="evenodd"
      opacity="0.4"
      style={{ mixBlendMode: 'lighten' }}
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M137.84 75.69c.05.29.34.47.63.47.23 0 .52-.17.59-.46l1.32-3.23 3.26-1.23c.29-.05.47-.34.47-.57 0-.29-.17-.58-.46-.64l-3.23-1.26-1.23-3.32c-.06-.23-.34-.41-.57-.41-.29 0-.58.17-.64.4l-1.26 3.29-3.32 1.17c-.29.05-.41.34-.41.63 0 .23.11.52.4.58l3.29 1.32 1.17 3.26zM131.17 68.8c.03.17.2.28.38.28.14 0 .31-.1.35-.27l.79-1.93 1.95-.74c.17-.03.28-.2.28-.34 0-.17-.1-.35-.27-.38l-1.93-.75-.74-1.98c-.03-.14-.2-.24-.34-.25-.17 0-.35.1-.38.24l-.75 1.96-1.98.7c-.17.03-.24.2-.25.38 0 .14.07.31.24.35l1.96.79.7 1.95z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      d="M121.98 75.94c-.43 0-.87-.14-1.25-.42-.58-.42-.88-1.14-.87-1.86.03-2.26.12-9.35.17-13.29.02-1.5 1.25-2.69 2.74-2.67l14.43.19c1.33.02 2.4 1.11 2.38 2.45l-.03 2.21c0 .5-.42.9-.91.89-.5 0-.9-.42-.89-.91l.03-2.21c0-.34-.26-.61-.6-.62l-14.43-.19c-.5 0-.91.39-.91.89l-.18 13.39c0 .18.11.27.18.3.07.04.21.08.35-.03l3.33-2.52 4.65.06c.5 0 .9.42.89.91 0 .5-.42.9-.91.89l-4.03-.05-2.83 2.15c-.39.3-.85.44-1.32.44z"
    ></path>
    <path
      fill="#000"
      d="m115.76 69.22.25.74c.56 1.76-.3 2.28-1.22 3.35-1.47 1.51-2.3 2.7-3.9 2.7v-3.02z"
      opacity="0.11"
    ></path>
    <path
      fill="#26A4DC"
      d="M108.74 76.06c-1.14-.78-1.4-2.36-.59-3.55l3.1-3.96c.81-1.19 2.39-1.52 3.52-.74 1.14.78 1.4 2.36.59 3.55l-3.1 3.96c-.81 1.19-2.39 1.52-3.52.74"
    ></path>
    <path
      fill="#7F1917"
      d="M46.93 69.32a.93.93 0 0 0-.71 1.27c2.27 5.34 8.63 8.21 14.78 6.48 5.12-1.44 8.7-5.71 9.01-10.54a.94.94 0 0 0-1.1-.98c-7.06 1.07-14.37 2.39-21.99 3.77z"
    ></path>
    <mask
      id="mask0_1152_62364"
      width="25"
      height="13"
      x="46"
      y="65"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'luminance' }}
    >
      <path
        fill="#fff"
        d="M46.93 69.32a.93.93 0 0 0-.71 1.27c2.27 5.34 8.63 8.21 14.78 6.48 5.12-1.44 8.7-5.71 9.01-10.54a.94.94 0 0 0-1.1-.98c-7.06 1.07-14.37 2.39-21.99 3.77z"
      ></path>
    </mask>
    <g mask="url(#mask0_1152_62364)">
      <path
        fill="#fff"
        d="m48.14 69.11 19.57-3.35.26 1.5c.12.72-.32 1.4-.98 1.52l-17.16 2.94c-.67.11-1.31-.38-1.43-1.1l-.26-1.5z"
      ></path>
      <path
        fill="#D47E79"
        d="M61.345 87.395c3.914-.67 6.586-4.14 5.968-7.748-.619-3.61-4.293-5.992-8.207-5.321-3.914.67-6.585 4.14-5.967 7.748.618 3.61 4.292 5.992 8.206 5.321"
      ></path>
    </g>
    <path
      stroke="#231F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
      d="M42.41 61.05c-.08-3.28 4.17-4.1 5.48-1.14"
    ></path>
    <path
      stroke="#AC5E27"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.95"
      d="M37.07 13.72a7.62 7.62 0 0 0-2.21 10.53 7.57 7.57 0 0 0-7.46-3.37"
    ></path>
    <path
      fill="#AC5E27"
      d="M72.74 27.18c-2.73-3.12-5.92-5.12-9.19-6.8-4.54-2.1-10.28-2.98-15.36-2.11l-3.44.59c-8.83 1.52-16.82 6.8-20.49 14.03-3.5 6.88-2.99 11.61-1.94 17.74l.24 1.38 34.65-5.96c5.76-.99 9.62-6.47 8.64-12.25l.02.09c.98 5.72 6.4 9.57 12.11 8.59l1.47-.25-.34-1.96c-.89-5.25-3.44-9.74-6.36-13.08z"
    ></path>
    <path
      fill="#9E501B"
      d="m26.65 51.39-4.12.84-.66-3.86a25.1 25.1 0 0 1-.2-7.37v-.04c.03-.2.05-.4.08-.6.03-.23.07-.45.11-.67.03-.2.07-.39.11-.59.05-.25.1-.49.17-.74.05-.2.11-.39.17-.59.02-.07.04-.14.06-.22 1.28-4.7 3.97-8.83 7.68-12.04 0 .05 0 .1.01.15-3.82 5-6.79 11.47-3.42 25.73z"
    ></path>
    <path
      fill="#fff"
      d="M51.3 89.69c23.296 0 42.18-18.885 42.18-42.18S74.595 5.33 51.3 5.33 9.12 24.215 9.12 47.51 28.005 89.69 51.3 89.69"
      opacity="0.3"
    ></path>
    <path
      fill="#1F93CB"
      d="m71.826 84.608-30.57 3.137a2.52 2.52 0 1 0 .515 5.014l30.57-3.138a2.52 2.52 0 1 0-.515-5.013"
    ></path>
    <path
      fill="#0A8DC6"
      d="m42.99 92.63-1.21.12c-1.39.13-2.62-.87-2.77-2.25-.01-.08-.01-.17-.01-.25 0-1.28.96-2.38 2.26-2.52l1.2-.12c-.89.5-1.45 1.48-1.34 2.56l.02.22c.1 1.08.87 1.95 1.84 2.24z"
    ></path>
    <path
      fill="#1F93CB"
      d="m7.47 49.71 2.35 13.73c.34 1.98-.99 3.86-2.97 4.2s-3.61-1.05-4.2-2.97A53 53 0 0 1 .3 50.94c-.08-2.01.99-3.86 2.97-4.2s3.86.99 4.2 2.97"
    ></path>
    <path
      fill="#fff"
      d="M76.49 26.44c-4.04-4.46-8.98-7.57-14.59-9.69-4.19-1.88-1.64-8.06 2.66-6.43 4.83 1.98 9.46 5.01 12.76 9.13 1.09 1.39 2.05 2.83 2.84 4.33 1.23 2.33-1.87 4.55-3.67 2.66M81.6 35.52c-1.04-1.01-1.35-2.24-1.7-3.58-.26-1.28.56-2.52 1.84-2.78 2.48-.54 4.03 3.22 3.71 5.22-.32 1.75-2.64 2.41-3.85 1.14"
      opacity="0.3"
    ></path>
    <path
      fill="#E0E0E0"
      d="M71.75 151.61c-15.02 3.66-34.87 1.88-35.86-7.76 0 0-1.38-23.96-2.6-40.54-.38-5.3 3.31-10.01 8.59-10.56-4.54 66.26 23.59 43.95 29.87 58.86"
      opacity="0.4"
    ></path>
    <path
      stroke="#EFEFEF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="18.45"
      d="m42.6 102.12 10.69 19.75 13.17-8.15"
    ></path>
    <path
      stroke="#DBDBDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.07"
      d="m51.56 99.29 5.19 9.59 4.85-3c4.33-2.68 10.02-1.34 12.7 2.99s1.34 10.02-2.99 12.7l-13.17 8.15a9.24 9.24 0 0 1-7.23 1.07 9.24 9.24 0 0 1-5.74-4.52l-6-11.08"
    ></path>
    <path
      fill="#26A4DC"
      d="M68.31 112.63c1.28-.49 1.91-1.98 1.4-3.32l-2.99-7.8c-.51-1.34-1.97-2.03-3.26-1.53-1.28.49-1.91 1.98-1.4 3.32l2.99 7.8c.51 1.34 1.97 2.03 3.26 1.53"
    ></path>
    <path
      fill="#26A4DC"
      d="M66.59 106.36c.78 1.13 2.38 1.38 3.55.56l8.97-6.23c1.18-.82 1.5-2.4.71-3.53-.78-1.13-2.38-1.38-3.55-.56l-8.97 6.23c-1.18.82-1.5 2.4-.71 3.53"
    ></path>
    <path
      fill="#26A4DC"
      d="M66.46 113.72a7.833 7.833 0 0 1 1.26-11 7.833 7.833 0 0 1 11 1.26 7.833 7.833 0 0 1-1.26 11 7.833 7.833 0 0 1-11-1.26"
    ></path>
    <path
      stroke="#DBDBDB"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.07"
      d="m56.75 108.88-3.28 2.08"
    ></path>
    <path
      fill="#FFF46C"
      d="M80.18 55.6c.31-.78.42-1.64.27-2.53l-2.01-11.74c-2.33-13.57-13.93-23.29-26.9-23.4 13.35-.41 25.4 9.12 27.71 22.62l1.96 11.42a4.4 4.4 0 0 1-1.03 3.63"
      opacity="0.23"
    ></path>
    <path
      fill="url(#paint10_linear_1152_62364)"
      fillRule="evenodd"
      d="M155.6 47.4c.1-.24.38-.34.63-.29.2.04.42.24.42.5l.54 3.02 2.58 1.67c.24.1.34.38.3.58-.05.25-.25.47-.51.47l-3.01.49-1.68 2.63c-.09.19-.37.29-.57.25-.25-.05-.47-.25-.48-.46l-.48-3.06-2.64-1.63c-.24-.1-.29-.37-.24-.62.04-.2.19-.43.45-.43l3.07-.53z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint11_linear_1152_62364)"
      fillRule="evenodd"
      d="M101.51 64.7c0-.17.15-.31.32-.34.13-.02.32.05.39.21l1.09 1.75 2.03.4c.17 0 .31.15.33.29.03.17-.04.36-.2.42l-1.76 1.06-.39 2.06c0 .14-.16.27-.29.3-.17.03-.36-.04-.41-.17l-1.06-1.79-2.05-.36c-.17 0-.27-.16-.3-.33-.02-.13.01-.32.17-.38l1.79-1.1.36-2.02z"
      clipRule="evenodd"
    ></path>
    <path
      fill="url(#paint12_linear_1152_62364)"
      fillRule="evenodd"
      d="M153.42 84.63c.1-.18.33-.23.51-.17.15.05.3.22.28.43l.14 2.38 1.84 1.52c.18.1.23.33.18.48-.06.19-.24.34-.44.32l-2.37.1-1.54 1.88c-.09.14-.31.19-.46.14-.19-.06-.34-.24-.33-.4l-.09-2.41-1.89-1.5c-.18-.1-.19-.31-.13-.5.05-.15.19-.31.39-.29l2.42-.12 1.49-1.85z"
      clipRule="evenodd"
    ></path>
    <defs>
      <linearGradient
        id="paint1_linear_1152_62364"
        x1="107.745"
        x2="116.29"
        y1="63.772"
        y2="4.306"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.35" stopColor="#FFD200"></stop>
        <stop offset="0.4" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.46" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.52" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.58" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.65" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.72" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.8" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.89" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_1152_62364"
        x1="151.884"
        x2="176.104"
        y1="72.896"
        y2="12.086"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.35" stopColor="#FFD200"></stop>
        <stop offset="0.4" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.46" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.52" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.58" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.65" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.72" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.8" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.89" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_1152_62364"
        x1="95.955"
        x2="118.231"
        y1="119.224"
        y2="66.471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.11" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="0.2" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.28" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.35" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.42" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.48" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.54" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.6" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.65" stopColor="#FFD200"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_1152_62364"
        x1="161.746"
        x2="144.951"
        y1="115.726"
        y2="68.676"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.11" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="0.2" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.28" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.35" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.42" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.48" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.54" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.6" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.65" stopColor="#FFD200"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_1152_62364"
        x1="133.762"
        x2="193.44"
        y1="55.839"
        y2="60.378"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.35" stopColor="#FFD200"></stop>
        <stop offset="0.4" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.46" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.52" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.58" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.65" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.72" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.8" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.89" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint6_linear_1152_62364"
        x1="134.073"
        x2="204.408"
        y1="63.614"
        y2="74.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.35" stopColor="#FFD200"></stop>
        <stop offset="0.4" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.46" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.52" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.58" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.65" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.72" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.8" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.89" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint7_linear_1152_62364"
        x1="80.67"
        x2="132.766"
        y1="55.831"
        y2="70.853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.11" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="0.2" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.28" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.35" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.42" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.48" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.54" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.6" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.65" stopColor="#FFD200"></stop>
      </linearGradient>
      <linearGradient
        id="paint8_linear_1152_62364"
        x1="73.952"
        x2="135.066"
        y1="62.531"
        y2="67.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.11" stopColor="#FFFEFB" stopOpacity="0.01"></stop>
        <stop offset="0.2" stopColor="#FFFCF2" stopOpacity="0.05"></stop>
        <stop offset="0.28" stopColor="#FFF9E2" stopOpacity="0.11"></stop>
        <stop offset="0.35" stopColor="#FFF5CB" stopOpacity="0.2"></stop>
        <stop offset="0.42" stopColor="#FFF0AD" stopOpacity="0.32"></stop>
        <stop offset="0.48" stopColor="#FFEA88" stopOpacity="0.46"></stop>
        <stop offset="0.54" stopColor="#FFE25D" stopOpacity="0.63"></stop>
        <stop offset="0.6" stopColor="#FFD92C" stopOpacity="0.82"></stop>
        <stop offset="0.65" stopColor="#FFD200"></stop>
      </linearGradient>
      <linearGradient
        id="paint9_linear_1152_62364"
        x1="139.727"
        x2="125.406"
        y1="83.07"
        y2="49.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.12" stopColor="#97248E"></stop>
        <stop offset="0.25" stopColor="#932890"></stop>
        <stop offset="0.39" stopColor="#893696"></stop>
        <stop offset="0.54" stopColor="#784CA0"></stop>
        <stop offset="0.7" stopColor="#606CAE"></stop>
        <stop offset="0.86" stopColor="#4294C0"></stop>
        <stop offset="1" stopColor="#23BFD4"></stop>
      </linearGradient>
      <linearGradient
        id="paint10_linear_1152_62364"
        x1="158.093"
        x2="152.379"
        y1="48.666"
        y2="55.144"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4C777"></stop>
        <stop offset="1" stopColor="#F18F00"></stop>
      </linearGradient>
      <linearGradient
        id="paint11_linear_1152_62364"
        x1="103.412"
        x2="101.457"
        y1="64.883"
        y2="70.356"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4C777"></stop>
        <stop offset="1" stopColor="#F18F00"></stop>
      </linearGradient>
      <linearGradient
        id="paint12_linear_1152_62364"
        x1="155.254"
        x2="150.244"
        y1="85.867"
        y2="90.346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F4C777"></stop>
        <stop offset="1" stopColor="#F18F00"></stop>
      </linearGradient>
      <radialGradient
        id="paint0_radial_1152_62364"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(4.35 -812.718 1767.609)scale(35.85)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.29" stopColor="#EADE00"></stop>
        <stop offset="0.37" stopColor="#EEE53B" stopOpacity="0.77"></stop>
        <stop offset="0.46" stopColor="#F3ED76" stopOpacity="0.54"></stop>
        <stop offset="0.55" stopColor="#F7F3A7" stopOpacity="0.34"></stop>
        <stop offset="0.63" stopColor="#FAF8CD" stopOpacity="0.19"></stop>
        <stop offset="0.71" stopColor="#FDFCE8" stopOpacity="0.09"></stop>
        <stop offset="0.78" stopColor="#FEFEF9" stopOpacity="0.02"></stop>
        <stop offset="0.84" stopColor="#fff" stopOpacity="0"></stop>
      </radialGradient>
    </defs>
  </svg>
);

export default AICommentIllustration;
